const MenuActionTypes = {
	TOGGLE_MENU: 'TOGGLE_MENU'
}

export default MenuActionTypes;